import {Injectable} from '@angular/core';
import {Produkt} from '../../../shared/models/produkt.model';
import {environment} from '../../../../environments/environment';
import {Observable} from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Repraesentation } from '../../../shared/models/repraesentation.model';
import * as fileSaver from 'file-saver';

@Injectable({
    providedIn: 'root'
})
export class ProdukteDataService {
    baseUrl: string = `${environment.apiUrl}/produkte`;

    constructor(private http: HttpClient) {
    }

    public getProdukte(): Observable<Produkt[]> {
        return this.http.get<Produkt[]>(this.baseUrl);
    }

    public getKontakteByRepraesentation(produktId: number): Observable<Repraesentation[]> {
        const query = `${this.baseUrl}/produkt/${produktId}/repraesentationen`;
        return this.http.get<Repraesentation[]>(query);
    }

    public createNewProduct(product: Produkt): Observable<Produkt> {
        const query = `${this.baseUrl}`;
        return this.http.post<Produkt>(query, product);
    }

    public deleteProduct(id: number): Observable<Produkt> {
        const query = `${this.baseUrl}/${id}`;
        return this.http.delete<Produkt>(query);
    }

    public updateProduct(product: Produkt): Observable<Produkt> {
        const query = `${this.baseUrl}/${product.id}`;
        return this.http.put<Produkt>(query, product);
    }

    public csvExport(produkteIds: number[], filename: string = 'produktesortiment_export.csv') {
        this.http.post(`${this.baseUrl}/csv`, produkteIds, {responseType: 'blob'})
            .subscribe(blob => fileSaver.saveAs(blob, filename));
    }
}
